/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { typeMap } from './const';

const typeKeys = Object.keys(typeMap);
export const equalAPI = (apiA: { url: string; isDefault: boolean }, apiB: { url: string; isDefault: boolean }): boolean => {
    if (!apiB || !apiA) {
        return apiA === apiB;
    }

    if (apiA.url !== apiB.url) {
        return false;
    }

    return apiA.isDefault === true && apiB.isDefault === true;
};

export const transformType = (type: string): string => {
    if (typeKeys.includes(type)) {
        return typeMap[type];
    }

    return type;
};

export const formatTip = (arr: any[], input: string): any[] => {
    const tip = [];
    const upper = input ? input.toUpperCase() : '';

    arr.forEach((i) => {
        const str = i.normal;
        if (str.toUpperCase().includes(upper)) {
            tip.push({
                normal: str.slice(0, upper.length),
                emphasis: str.slice(upper.length),
            });
        }
    });

    return tip;
};
export const trim = (str: string): string => {
    const reg = /\s/;
    let i = 0;

    while (i < str.length && reg.test(str[i])) {
        i++;
    }

    return str.slice(i);
};
